import '../styles/Input.css';
import { useState, useEffect } from 'react'
import { useRef } from 'react';
import fullHeartLogo from '../assets/full_heart.png'
import halfHeartLogo from '../assets/half_heart.png'
import emptyHeartLogo from '../assets/empty_heart.png'
import winLogo from '../assets/win1.gif'
import looseLogo from '../assets/loose.gif'
import link from '../assets/link.png'
import { useTranslation } from 'react-i18next';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;



function InputCharacter({rows, rowsUpdate, characterNow, characterFind, nbTestMax, nbTest, dateFormatee, gameMode}) {   
    const { t } = useTranslation();
    const fullHeart = (10-nbTest)/2
    const halfHeart = nbTest%2
    const emptyHeart = nbTest/2

    function myFunction() {
		document.getElementById("dropdown-input").classList.toggle("show");
    }

    function handleBlur() {
        document.getElementById("dropdown-input").classList.toggle("show");
    }

    function filterFunction() {
        var input, filter, a, i;
        input = document.getElementById("myInput");
        filter = input.value.toUpperCase();
        var div = document.getElementById("dropdown-input");
        a = div.getElementsByClassName("dropdown-input-div");
        var found = false; // Variable pour suivre si un élément correspondant est trouvé
    
        for (i = 0; i < a.length; i++) {
            var txtValue = a[i].textContent || a[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                a[i].style.display = "";
                found = true; // On a trouvé au moins un élément correspondant
            } else {
                a[i].style.display = "none";
            }
        }
    
        // Supprimer un éventuel ancien message "introuvable"
        var noResultMessage = div.querySelector(".no-results");
        if (noResultMessage) {
            div.removeChild(noResultMessage);
        }

        // Vérifier si aucun élément n'a été trouvé et afficher "Pas d'objet trouvé"
        if (!found) {
            var noResult = document.createElement("div");
            noResult.textContent = t('inputCharacter.nosearch');
            noResult.classList.add("no-results");
            div.appendChild(noResult);
        }
    }

    function addInput(dateFormatee, id_personnage, nom_personnage, image_personnage){
        var rowsLength = rows.length + 1
        var rowAdd = {dateFormatee, gameMode, rowsLength, id_personnage, nom_personnage, image_personnage}

        rowsUpdate ([
            rowAdd, ...rows
        ])
        
        localStorage.setItem('rows-characters', JSON.stringify(rows))
    
    }

    function viderLocalStorage(key){
        localStorage.removeItem(key)
        rowsUpdate ([])
    }

    const [data, setData] = useState([]);
    useEffect(() => {
        // console.log('Fetching data from API...');
        fetch(URL_BACKEND+'/api/characters')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => { 
                setData(data); 
                console.log('data : ',data)
                majData (rows, data);
            })
            .catch(error => { console.error('Error fetching data:', error); });
    }, []);

    useEffect(() => {
        if (data.length > 0) {
            const newData = data.filter(characters => !rows.some(row => row.id_personnage === characters.id_personnage));
            setData(newData);
        }
    }, [rows]);

    function majData (rows, data) {
        if (data.length > 0) {
            const newData = data.filter(characters => !rows.some(row => row.id_personnage === characters.id_personnage));
            setData(newData);
        }
    }

    const bounceEffectRef = useRef(null);  // Crée une référence pour l'élément "bounce-effect"
    useEffect(() => {
        // Si le characterFind est activé, défiler vers l'élément avec la classe "bounce-effect"
        if (characterFind === 1 && bounceEffectRef.current) {
            bounceEffectRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [characterFind]);  // Déclenche l'effet quand characterFind change

    const confettiContainerRef = useRef(null);  // Référence pour le conteneur de confettis
    useEffect(() => {
        if (characterFind === 1) {
            // Générer des confettis aléatoires
            const confettiContainer = confettiContainerRef.current;
            for (let i = 0; i < 100; i++) {  // Créer 50 confettis
                const emoji = ['🎉', '🎊', '🥳', '✨', '🎁'][Math.floor(Math.random() * 5)];  // Choisir un emoji aléatoire
                const confetti = document.createElement('div');
                confetti.classList.add('confetti');
                confetti.style.left = `${(Math.random() * 90)+1}vw`;  // Position aléatoire horizontalement
                confetti.style.animationDelay = `${Math.random() * 2}s`;  // Délai d'animation aléatoire
                confetti.textContent = emoji;
                confettiContainer.appendChild(confetti);

                // Enlever les confettis après leur animation
                setTimeout(() => {
                    confetti.remove();
                }, 3000);  // Les confettis disparaissent après 3 secondes
            }
        }
    }, [characterFind]);  // Ne générer des confettis que si characterFind est égal à 1




	return (
        <div id="confetti-container" ref={confettiContainerRef}>
            <div 
            className= 
                { characterFind === 1 ? "saisie bounce-effect"  
                    : "saisie"
                }
            >
                { characterFind === 1 ?
                    <div>
                        <div>
                            <div className="saisie-title"  ref={bounceEffectRef}>
                                <h2>{t('inputCharacter.win')}</h2>
                                <img src={winLogo} alt='win' />
                            </div>
                            <div className='saisie-find'>
                                <img src={`/images/characters/${characterNow.image_personnage}`} alt={characterNow.nom_personnage} /><br />
                                {characterNow.nom_personnage}
                            </div>                            
                            <br />
                            { /* <button onClick={() => viderLocalStorage('rows')} >Recommencer</button> */ }
                        </div> 
                    </div>
                : nbTestMax === 0 ? 
                    <div>
                        <h2>{t('inputCharacter.guess')}</h2>
                        <div className="life">
                        {/*    {nbTest}/10 */}
                        <img src={link} alt="link" className='link' />
                        {/* Utilisation de map pour générer une liste d'éléments */}
                        {Array.from({ length: fullHeart }, (_, index) => (
                            <img key={`${index}-fullheart`} src={fullHeartLogo} alt="fullHeart" className='heart' />
                        ))}
                        {Array.from({ length: halfHeart }, (_, index) => (
                            <img key={`${index}-halfHeart`} src={halfHeartLogo} alt="halfHeart" className='heart' />
                        ))}
                        {Array.from({ length: emptyHeart }, (_, index) => (
                            <img key={`${index}-emptyHeart`} src={emptyHeartLogo} alt="emptyHeart" className='heart' />
                        ))}
                        </div>
                        <div className="dropdown">
                            <div id="myDropdown" className="dropdown-content" >
                                <input type="text" placeholder={t('inputCharacter.search')} id="myInput" className="dropdown-content"  onKeyUp={filterFunction} onFocus={myFunction} onBlur={handleBlur} />
                                <div className="dropdown-input" id="dropdown-input" >
                                {data.map(character => (
                                    <div key={`${character.id_personnage}-div`} className='dropdown-input-div' onMouseDown={() => addInput(dateFormatee, character.id_personnage, character.nom_personnage, character.image_personnage)}>
                                        <div key={`${character.id_personnage}-item`} className='dropdown-input-item'   >
                                            <span>{character.nom_personnage}</span>
                                        </div>
                                    </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                    : <div>
                        <div className="saisie-title">
                            <h2>{t('inputCharacter.lose')}</h2>
                            <img src={looseLogo} alt='loose' />
                        </div>
                        <div className='saisie-find'>
                            <img src={`/images/characters/${characterNow.image_personnage}`} alt={characterNow.nom_personnage} /><br />
                            {characterNow.nom_personnage}
                        </div>
                        <br />
                        { /* <button onClick={() => viderLocalStorage('rows')} >Recommencer</button> */ }
                    </div>
                }
            
            </div>
        </div>

	)
}

export default InputCharacter
